/* Detailing1 — Steuersatz + guenstigster Versand (2026-09, Phase 2)
 * Liest #d1-ts-config (snippets/d1-ts-config.liquid) und fuellt alle [data-d1-ts]-Elemente
 * (snippets/d1-tax-shipping.liquid).
 *  1. Sofort: Regelmodell = Shopify-Versandprofil (generiert, alle Waehrungen; echte Bestellungen zahlen den
 *     hinterlegten Betrag in Landeswaehrung, Beleg 2026-09-25).
 *  2. Danach: Storefront-API cartCreate mit Lieferadresse -> Shopifys eigene Lieferoptionen fuer genau diesen
 *     Warenkorb (+ Produkt auf der Produktseite), inkl. Spedition, Mischwarenkorb, Rabattcodes. Shopify gewinnt;
 *     weicht das Modell ab, steht data-d1-ts-drift="1" am <html> (Regel-Export nachziehen).
 *  Nie eine unsichere Zahl: bei Unklarheit bleibt der serverseitige Fallback-Text stehen.
 *  MwSt.-Betrag (2026-10): "inkl. 9,89€ MwSt. (19%)" — nur auf den Produktpreis, je Zeile gerundet wie Shopify.
 *  Firmenkonto (C.netB2b): Preise netto, Hinweis "zzgl. 1,58€ MwSt. (19%)" (Jasper 2026-10-20).
 *  DAP-Laender (C.dap, snippets/d1-dap-state): "exkl. MwSt. und Zoll" bzw. "exkl. Steuern und Zoll" (Jasper 2026-10-23). */
(function () {
  'use strict';
  var cfgEl = document.getElementById('d1-ts-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!C || !C.on) return;
  var geo = C.geo || {};
  C.tax = (geo.tax === undefined) ? null : geo.tax;
  C.zip = geo.zip || '';
  C.prov = geo.prov || '';
  var SF = (C.live && C.sf && C.sf.token) ? C.sf : null;

  var cart = C.cart || null;   // {total, weight, count, cur, token, ship, lines:[{id,q}], codes:[]}
  var rules = parseRules(geo.rules || '');
  var renderTimer = null;
  var inflight = {};           // key -> true
  var quoteTimers = {};        // key -> timeout

  function parseRules(s) {
    if (!s) return [];
    return s.split(';').filter(Boolean).map(function (x) {
      var f = x.split('|');
      return { minG: +f[0], maxG: +f[1], minC: +f[2], maxC: +f[3], amount: +f[4], cur: f[5], name: f[6] || '' };
    });
  }

  /* Guenstigster Tarif, dessen Gewichts- und Preisbedingungen erfuellt sind. null = nicht sicher bestimmbar. */
  function cheapest(grams, cents, cur) {
    if (!rules.length) return null;
    var best = null, unsure = false;
    rules.forEach(function (r) {
      if (r.minG >= 0 && grams < r.minG) return;
      if (r.maxG >= 0 && grams > r.maxG) return;
      if (r.minC >= 0 || r.maxC >= 0) {
        if (cur !== C.shopCur) { unsure = true; return; } // Preisbedingung gilt in Shopwaehrung
        if (r.minC >= 0 && cents < r.minC) return;
        if (r.maxC >= 0 && cents > r.maxC) return;
      }
      if (r.cur !== cur) { unsure = true; return; }
      if (!best || r.amount < best.amount) best = r;
    });
    if (!best) return null;
    if (unsure && best.amount > 0) return null; // eine nicht pruefbare Regel koennte guenstiger sein
    return { amount: best.amount, cur: best.cur, name: best.name };
  }

  function group(n, dec, ts, ds) {
    var p = n.toFixed(dec).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
    return p.join(ds);
  }

  function money(cents, cur) {
    var v = cents / 100;
    var fmt = (cur === C.cur && C.money) ? C.money : null;
    if (!fmt) return v.toFixed(2) + ' ' + cur;
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount', s;
    switch (key) {
      case 'amount_no_decimals': s = group(v, 0, ',', '.'); break;
      case 'amount_with_comma_separator': s = group(v, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': s = group(v, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': s = group(v, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': s = group(v, 0, ' ', ','); break;
      case 'amount_with_space_separator': s = group(v, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': s = group(v, 2, ' ', '.'); break;
      default: s = group(v, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, s).replace(/<[^>]+>/g, '').trim();
  }

  function rateStr() {
    var pct = Math.round(C.tax * 10000) / 100, s;
    try { s = new Intl.NumberFormat(C.lang || 'de', { maximumFractionDigits: 2 }).format(pct); } catch (e) { s = String(pct); }
    return s + '%'; // ohne Leerzeichen wie die Rabatt-Badges (Jasper 2026-10-20)
  }

  /* MwSt.-Betrag in Cent aus einem Bruttobetrag in Cent: round(brutto x bp / (10000 + bp)), kaufmaennisch, nur
   * Ganzzahlen — dieselbe Rechnung wie im Snippet und wie Shopify je Zeile. */
  function vatOf(cents) {
    var bp = Math.round(C.tax * 10000), den = 10000 + bp;
    return Math.floor((cents * bp * 2 + den) / (2 * den));
  }

  /* Betrag fuer den Steuerteil eines Elements; -1 = keinen Betrag zeigen.
   * Produkt/Sticky: Stueckpreis der Variante (wie der Preisblock, nie x Menge). Warenkorb: Wert aus dem Snippet
   * (data-vat, je Zeile nach Rabatten) — Warenkorb und Drawer werden bei jeder Aenderung serverseitig neu gerendert. */
  /* Stueckpreis, den der Preisblock gerade zeigt (Original-Element des Themes, brutto). Folgt der Mengenvorteil-Staffel
   * (B2B: „Ab 6 Stück“ setzt den Staffelpreis per atc-price.js) — data-price ist nur der Variantenpreis (Jasper 2026-10-20). */
  function shownCents(el) {
    var scope = el.closest('.js-product');
    var p = scope && scope.querySelector('.product-info__price .price__current:not([data-d1net-el])');
    if (!p) return null;
    var m = /(\d{1,3}(?:[.,\u00a0 ]\d{3})+|\d+)[.,](\d{2})(?!\d)/.exec(p.textContent);
    return m ? parseInt(m[1].replace(/\D/g, ''), 10) * 100 + parseInt(m[2], 10) : null;
  }

  function vatFor(el) {
    // nur in Shopwaehrung: in Fremdwaehrung rechnet Shopify die MwSt. in EUR und rechnet um
    if (!C.vat || !C.taxIncl || !(C.tax > 0) || C.taxExempt || C.cur !== C.shopCur) return -1;
    var ctx = el.dataset.d1Ts, n;
    if (ctx === 'cart') {
      n = parseInt(el.dataset.vat, 10);
      return (n > 0) ? n : -1;
    }
    if (ctx === 'product' || ctx === 'sticky') {
      if (el.dataset.bundle === '1') return -1;
      n = shownCents(el) || parseInt(el.dataset.price, 10);
      return (n > 0) ? vatOf(n) : -1;
    }
    return -1;
  }

  /* ship: {amount,cur} = sicherer Betrag | null = unbekannt (generischer Text) | false = kein Versand noetig */
  function paint(el, ship, source) {
    var parts = [];
    if (el.dataset.taxable !== '0') {
      var vat = vatFor(el);
      if (C.dap) parts.push(C.dap === 'vat' ? C.t.exclDapVat : C.t.exclDapTax);
      else if (C.taxExempt || C.tax === 0) parts.push(C.t.excl);
      else if (C.tax > 0 && C.netB2b) {
        // Firmenkonto: Preise stehen netto (d1-b2b-netto.js), die MwSt. kommt dazu
        if (vat >= 0) parts.push((C.b2bRc ? C.t.plusAmtRc : C.t.plusAmt).replace('[rate]', rateStr()).replace('[amount]', money(vat, C.cur)));
        else parts.push((C.b2bRc ? C.t.plusTaxRc : C.t.plusTax).replace('[rate]', rateStr()));
      }
      else if (C.tax > 0 && C.taxIncl && vat >= 0 && C.t.inclAmt) parts.push(C.t.inclAmt.replace('[rate]', rateStr()).replace('[amount]', money(vat, C.cur)));
      else if (C.tax > 0) parts.push((C.taxIncl ? C.t.incl : C.t.plusTax).replace('[rate]', rateStr()));
      else if (C.taxIncl) parts.push(C.t.inclPlain);
    }
    if (ship !== false) {
      if (ship && ship.amount === 0 && C.zero === 'free') parts.push(C.t.free);
      else if (ship) parts.push(C.t.plus.replace('[amount]', money(ship.amount, ship.cur)));
      else parts.push(C.t.plusGeneric);
    }
    var html = parts.join(C.t.sep);
    if (el.innerHTML !== html) el.innerHTML = html;
    el.dataset.d1TsState = ship === false ? 'noship' : (ship ? (source || 'model') : 'generic');
  }

  function currentQty(el) {
    var scope = el.closest('.js-product') || document;
    var q = scope.querySelector('input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return (n > 0) ? n : 1;
  }

  function cartKey() {
    if (!cart) return '';
    return [C.cc, cart.cur, (cart.lines || []).map(function (l) { return l.id + 'x' + l.q; }).join(','), (cart.codes || []).join(',')].join('|');
  }

  /* ---- Cache fuer Storefront-Angebote (je Warenkorbstand, 5 min) ---- */
  function cacheAll() {
    try { return JSON.parse(sessionStorage.getItem('d1-ts-sf') || '{}') || {}; } catch (e) { return {}; }
  }
  function cacheGet(key) {
    var v = cacheAll()[key];
    return (v && Date.now() - v.at < 300000) ? v : null;
  }
  function cacheSet(key, val) {
    var all = cacheAll(), keys = Object.keys(all);
    if (keys.length > 40) keys.slice(0, keys.length - 40).forEach(function (k) { delete all[k]; });
    val.at = Date.now(); all[key] = val;
    try { sessionStorage.setItem('d1-ts-sf', JSON.stringify(all)); } catch (e) { /* privat */ }
  }

  /* ---- Storefront-API: Lieferoptionen fuer einen hypothetischen Warenkorb ---- */
  var SF_Q = 'mutation($input:CartInput!,$cc:CountryCode!,$lang:LanguageCode!) @inContext(country:$cc,language:$lang){' +
    'cartCreate(input:$input){userErrors{message} cart{deliveryGroups(first:5){nodes{deliveryOptions{title estimatedCost{amount currencyCode}}}}}}}';
  function sfQuote(lines, codes) {
    var addr = { countryCode: C.cc, zip: (C.addr && C.addr.zip) || C.zip };
    var prov = (C.addr && C.addr.prov) || C.prov;
    if (prov) addr.provinceCode = prov;
    var input = {
      lines: lines.map(function (l) { return { merchandiseId: 'gid://shopify/ProductVariant/' + l.id, quantity: l.q }; }),
      buyerIdentity: { countryCode: C.cc },
      delivery: { addresses: [{ address: { deliveryAddress: addr }, selected: true, oneTimeUse: true }] }
    };
    if (codes && codes.length) input.discountCodes = codes;
    return fetch('/api/' + (SF.ver || '2026-07') + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF.token },
      body: JSON.stringify({ query: SF_Q, variables: { input: input, cc: C.cc, lang: String(C.lang || 'de').toUpperCase() } })
    }).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      var c = d && d.data && d.data.cartCreate && d.data.cartCreate.cart;
      if (!c || !c.deliveryGroups || !c.deliveryGroups.nodes.length) return null;
      var total = 0, cur = null, names = [];
      for (var i = 0; i < c.deliveryGroups.nodes.length; i++) {
        var opts = c.deliveryGroups.nodes[i].deliveryOptions, best = null;
        if (!opts || !opts.length) return null;
        opts.forEach(function (o) {
          var cents = Math.round(parseFloat(o.estimatedCost.amount) * 100);
          if (best === null || cents < best.c) best = { c: cents, cur: o.estimatedCost.currencyCode, name: o.title };
        });
        if (cur && best.cur !== cur) return null;
        cur = best.cur; total += best.c; names.push(best.name);
      }
      if (cur !== C.cur) return null; // Waehrung passt nicht zur Anzeige -> nicht verwenden
      return { amount: total, cur: cur, name: names.join(' + ') };
    });
  }

  function requestQuote(key, lines, model) {
    if (!SF || inflight[key]) return;
    clearTimeout(quoteTimers[key]);
    quoteTimers[key] = setTimeout(function () {
      inflight[key] = true;
      sfQuote(lines, cart.codes).then(function (res) {
        delete inflight[key];
        if (!res) return;
        var drift = !!model && (model.amount !== res.amount || model.cur !== res.cur);
        res.drift = drift;
        cacheSet(key, res);
        if (drift) {
          document.documentElement.setAttribute('data-d1-ts-drift', '1');
          if (window.console) console.warn('[d1-tax-shipping] Regelmodell weicht von Shopify ab', model, res);
        }
        scheduleRender();
      }).catch(function () { delete inflight[key]; });
    }, 250);
  }

  function evalEl(el) {
    var ctx = el.dataset.d1Ts;
    if (ctx === 'sticky') { paint(el, false); return; }
    if (!cart) return;
    var lines, key, sped, grams, cents, model;
    if (ctx === 'cart') {
      if (!cart.count) { paint(el, null); return; }
      if (!cart.ship) { paint(el, false); return; }
      lines = cart.lines || [];
      key = 'c|' + cartKey();
      sped = el.dataset.sped === '1';
      grams = cart.weight; cents = cart.total;
    } else {
      if (el.dataset.ship === '0') { paint(el, false); return; }
      var vid = el.dataset.vid, qty = ctx === 'product' ? currentQty(el) : 1;
      lines = (cart.lines || []).slice();
      if (vid) {
        var hit = false;
        lines = lines.map(function (l) { if (String(l.id) === String(vid)) { hit = true; return { id: l.id, q: l.q + qty }; } return l; });
        if (!hit) lines.push({ id: vid, q: qty });
      }
      key = 'p|' + cartKey() + '|' + vid + 'x' + qty;
      sped = el.dataset.sped === '1' || cartSped();
      grams = cart.weight + (parseInt(el.dataset.weight, 10) || 0) * qty;
      cents = cart.total + (parseInt(el.dataset.price, 10) || 0) * qty;
    }
    model = sped ? null : cheapest(grams, cents, cart.cur);
    var cached = cacheGet(key);
    if (cached) { paint(el, cached, 'live'); return; }
    paint(el, model, 'model');
    if (ctx === 'card') return; // Karten: nur Modell (kein Abruf je Karte)
    requestQuote(key, lines, model);
  }

  function cartSped() {
    var el = document.querySelector('[data-d1-ts="cart"]');
    return el ? el.dataset.sped === '1' : false;
  }

  function renderAll() {
    document.querySelectorAll('[data-d1-ts]').forEach(evalEl);
  }
  function scheduleRender() {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(renderAll, 0);
  }

  function fromCartJson(c) {
    var codes = [];
    (c.discount_codes || []).forEach(function (d) { if (d && d.code && d.applicable !== false) codes.push(d.code); });
    return { total: c.total_price, weight: c.total_weight, count: c.item_count, cur: c.currency, token: c.token || '',
      ship: !!c.requires_shipping, codes: codes,
      lines: (c.items || []).map(function (i) { return { id: i.variant_id, q: i.quantity }; }) };
  }

  var refreshing = null;
  function refreshCart() {
    if (refreshing) return refreshing;
    refreshing = fetch(C.routes.cart + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = fromCartJson(c); refreshing = null; renderAll(); })
      .catch(function () { refreshing = null; });
    return refreshing;
  }

  /* Ereignisse des Themes */
  document.addEventListener('on:variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    var scope = (e.target && e.target.closest) ? e.target.closest('.js-product') : null;
    (scope || document).querySelectorAll('[data-d1-ts="product"],[data-d1-ts="sticky"]').forEach(function (el) {
      el.dataset.weight = v.weight || 0;
      el.dataset.price = v.price;
      el.dataset.vid = v.id;
      el.dataset.ship = v.requires_shipping === false ? '0' : '1';
      el.dataset.taxable = v.taxable === false ? '0' : '1';
      el.dataset.sped = (el.dataset.spedVids || '').indexOf(',' + v.id + ',') >= 0 ? '1' : '0';
      evalEl(el);
    });
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'quantity') scheduleRender();
  });
  document.addEventListener('on:cart:add', function (e) {
    var c = e.detail && e.detail.cart;
    if (c && typeof c.total_weight === 'number' && c.items) { cart = fromCartJson(c); renderAll(); }
    else refreshCart();
  });
  document.addEventListener('on:line-item:change', function () { refreshCart(); });
  document.addEventListener('dispatch:cart-drawer:refresh', function () { refreshCart(); });

  /* Drawer / Sections werden neu gerendert: neue Hinweis-Elemente nachziehen */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      // Preisblock geaendert (Staffelpreis bei Mengenaenderung, Bundle-Sync): MwSt.-Betrag neu rechnen
      var t = muts[i].target;
      var te = t && (t.nodeType === 1 ? t : t.parentElement);
      if (te && te.closest && te.closest('.product-info__price')) { scheduleRender(); return; }
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j];
        if (n.nodeType === 1 && (n.hasAttribute('data-d1-ts') || n.querySelector('[data-d1-ts]'))) { scheduleRender(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  renderAll();
  window.d1TaxShipping = { config: C, cheapest: cheapest, quote: sfQuote, refresh: refreshCart,
    get cart() { return cart; }, get cache() { return cacheAll(); } };
})();
